var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({model:{value:(_vm.localvalue),callback:function ($$v) {_vm.localvalue=$$v},expression:"localvalue"}},'v-text-field',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }